import i18n from "@/i18n";
import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";

export const translateI18n = (textI18n?: PortalAdapterApi.I18nObject): string => {
  if (!textI18n) return "";
  const currentLocale = i18n.locale as unknown as PortalAdapterApi.Language;
  const languageCode = currentLocale.split("_")[0] as unknown as PortalAdapterApi.Language;

  return (
    textI18n.languageList[currentLocale] || textI18n.languageList[languageCode] || translateToFallbackLanguage(textI18n)
  );
};

const translateToFallbackLanguage = (textI18n: PortalAdapterApi.I18nObject): string => {
  const fallbackLanguage = textI18n.fallbackLanguage as PortalAdapterApi.Language;
  return textI18n.languageList[fallbackLanguage] || "";
};
